export default __webpack_public_path__ + "static/media/rnr-sports-table-14-cn.7c916eca.webp";